import axios from "axios";
import appconfig from '../../../AppConfig';
import { debug } from "../../../common/utils";
import { UPDATE_PICTURE_ISDELETED } from "../pictures.actions";

export const updatePictureIsDeletedApi = async (
    dispatch: any,
    pictureId: number,
    isDeleted: boolean,
) => {
    const url = `products/updatePictureIsDeleted/${pictureId}/${isDeleted}`;
    const config = {
        baseURL: appconfig.baseURL,
    }

    await axios.post(url, null, config)
        .then(response => {
            debug("!!! API - updatePictureIsDeletedApi !!!");

            if (response && response.data) {
                dispatch({
                    type: UPDATE_PICTURE_ISDELETED,
                    pictureId,
                    isDeleted,
                });
            }

            debug(response);
        })
        .catch(err => {
            console.log(err);
            // alert(err);
        });
};